import {
  ChangeDetectionStrategy,
  Component,
  createComponent,
  EnvironmentInjector,
  inject,
  OnInit,
} from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HelpModalComponent } from './help-modal.directive';
import { PointCloudHelpModalComponent } from './point-cloud-help-modal.component';
import { VideoHelpModalComponent } from './video-help-modal.component';

@Component({
  selector: 'h3-split-view-help-modal',
  templateUrl: './help-modal.directive.html',
  styleUrls: ['./help-modal.directive.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SplitViewHelpModalComponent
  extends HelpModalComponent
  implements OnInit
{
  private envInjector = inject(EnvironmentInjector);
  private data = inject(MAT_DIALOG_DATA);

  ngOnInit() {
    const pointCloudHelp = createComponent(PointCloudHelpModalComponent, {
      environmentInjector: this.envInjector,
      elementInjector: this.data.injector,
    });
    const videoCloudHelp = createComponent(VideoHelpModalComponent, {
      environmentInjector: this.envInjector,
      elementInjector: this.data.injector,
    });

    pointCloudHelp.instance.setUpShorcuts();
    videoCloudHelp.instance.setUpShorcuts();

    this.config = {
      tabs: [
        ...pointCloudHelp.instance.config.tabs,
        ...videoCloudHelp.instance.config.tabs,
      ],
    };
  }
}
